export default "__VITE_ASSET__324c32cc__"